import request from './index'

export const getAnalysis = (carId,listQuery) => {
	return request({
	  url: '/data/getAnalysis',
	  method: 'post',
	  data: {
			carId:carId,
			startTime:listQuery.startTime,
			endTime:listQuery.endTime,
			pageIndex:listQuery.pageIndex,
			pageSize:listQuery.pageSize
	  }
	})
}

export const reportCsv= (carId,startTime,endTime) => {
	return request({
		url:'/data/analysisCsv/'+carId+'/'+startTime+'/'+endTime,
		method:'get',
		responseType: 'blob'
	})
}

// export const getReport = (carId,listQuery) => {
// 	return request({
// 	  url: '/data/getReport',
// 	  method: 'post',
// 	  data: {
// 			carId:carId,
// 			startTime:listQuery.startTime,
// 			endTime:listQuery.endTime,
// 			dateType:listQuery.dateType
// 	  }
// 	})
// }

export const getReport = (command_id,entityId,carId,listQuery) => {
  return request({
    url: '/screen/index/report',
    method: 'post',
    data: {
		command_id:command_id,
		entityId:entityId,
		carId:carId,
		timeStart:listQuery.startTime,
		timeEnd:listQuery.endTime,
		datetype:listQuery.dateType
    }
  })
}

export const getReportWeather = (entityId,listQuery) => {
  return request({
    url: '/data/getReportWeather',
    method: 'post',
    data: {
		entityId:entityId,
		startTime:listQuery.startTime,
		endTime:listQuery.endTime,
		dateType:listQuery.dateType
    }
  })
}

export const getReportWork = (entityId,carId,startTime) => {
  return request({
    url: '/data/getReportWork',
    method: 'post',
    data: {
		entityId:entityId,
		carId:carId,
		startTime:startTime
    }
  })
}

export const reportWxPush = (id) => {
  return request({
    url: '/data/reportWxPush',
    method: 'post',
    data: {
			reportId:id
    }
  })
}

